module.exports = {
  // baseURL: "https://tradingbotnft.herokuapp.com/api/", 
  // baseURL: "https://tradingbotapi.fly.dev/api/"
  baseURL: "https://trading-bot-api.vercel.app/api/",
};
